export class FilterDropdown {
    static create (dropdownSelector, callback) {
        const dropdown = $(dropdownSelector);

        dropdown.on('change', (event) => {
            event.preventDefault();

            const queryString = FilterDropdown.generateUpdatedQueryString(
                dropdown.attr('name'),
                dropdown.val(),
                window.location.search
            );

            const url = `${window.location.origin}${window.location.pathname}?${queryString}`;

            callback(url);
        });
    }

    static generateUpdatedQueryString (name, value, currentQueryString) {
        const queryStringObject = new URLSearchParams(currentQueryString);
        queryStringObject.set(name, value);

        // clear any existing pagination
        delete queryStringObject.start;

        return queryStringObject.toString();
    }
}



// WEBPACK FOOTER //
// ./src/js/app/fund-finder/filter-dropdown.js